module.exports = __webpack_public_path__ + "img/success.33fcaadd.svg";